/* @flow */

import React, { Component } from 'react';
import {
  HashRouter as Router,
  NavLink,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { Segment, Menu } from 'semantic-ui-react';
import * as NewsActions from 'news/actions';
import ImagesCard from './components/ImagesCard';
import EditoCard from './components/EditoCard';
import DiffusionCard from './components/DiffusionCard';

type Props = {
  loadInitialDatas: () => void,
};

class Edit extends Component {
  props: Props;

  componentDidMount() {
    console.log('MOUNT');
    this.props.loadInitialDatas();
  }

  render() {
    console.log(this.props);
    return (
      <Router>
        <div>
          <Segment attached>
            <Menu secondary>
              <NavLink
                exact
                to="/images"
                activeClassName="active"
                className="item"
              >
                Images
              </NavLink>
              <NavLink
                exact
                to="/edito"
                activeClassName="active"
                className="item"
              >
                Contenu éditorial
              </NavLink>
              <NavLink
                exact
                to="/diffusion"
                activeClassName="active"
                className="item"
              >
                Diffusion
              </NavLink>
            </Menu>
          </Segment>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/images" />} />
            <Route exact path="/images">
              <ImagesCard />
            </Route>
            <Route exact path="/edito">
              <EditoCard />
            </Route>
            <Route exact path="/diffusion">
              <DiffusionCard />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default connect(state => state, {
  loadInitialDatas: NewsActions.loadInitialDatas,
})(Edit);



// WEBPACK FOOTER //
// ./src/modules/news/Edit.js